// extracted by mini-css-extract-plugin
export default {"overlay":"cTrsk","dialog":"Ub5DA","heading":"uVCcX","section":"NW0om","section--darker":"PbkXb","section--flexRight":"TJhUg"};